import { createAction } from "@reduxjs/toolkit";
import * as types from "../types/actions";

export const login = createAction(types.LOGIN);
export const logout = createAction(types.LOGOUT);
